// safeFetch.js
export async function safeFetch(url, options = {}) {
  const token = localStorage.getItem("labour_law_token");

  const finalOptions = {
    ...options,
    headers: {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };

  try {
    const response = await fetch(url, finalOptions);

    if (response.status === 401 || response.status === 403) {
      // Try to read message but do NOT depend on it
      let msg = "";
      try {
        const ct = (response.headers.get("content-type") || "").toLowerCase();
        if (ct.includes("application/json")) {
          const data = await response.clone().json();
          msg = data?.detail || data?.message || "";
        } else {
          msg = await response.clone().text();
        }
      } catch (e) {}

      // Any auth failure => hard logout
      localStorage.clear();
      window.location.assign("/login");

      return Promise.reject(new Error(msg || "Unauthorized"));
    }

    return response;
  } catch (error) {
    console.error("Network error:", error);
    return new Response(
      JSON.stringify({ error: "Network error. Please check connection." }),
      { status: 503, headers: { "Content-Type": "application/json" } }
    );
  }
}
